module.exports = __webpack_public_path__ + "static/media/community1.c2da4c5d.svg";